import { CryptocurrencyType, resolveCryptocurrencyType } from "@/utils/currencyResolver";

/**
 * 📄 Class that represents a single coin on the dashboard
 */
export default class Coin {
  constructor(
    public name: string,
    public value: number,
    public percentageOfAll: number,
    public amount: number
  ) {}
}

 export class CombinedCoin extends Coin {
  constructor(
    public name: string,
    public value: number,
    public percentageOfAll: number,
    public containedCoins: string
  ) { 
    super(name, value, percentageOfAll, 0)
  }
}

/**
 * 🔨 Converts ordinary distribution between coins into a general divided into stable coin and crypto
 * @param balanceInUsePerCoin 
 * @returns 
 */
export function  mapToBalanceInUsePerCoinType(balanceInUsePerCoin: Coin[]) {
  let stableCoinBalance = { value: 0, percentageOfAll: 0, containedCoins: "" };
  let cryptoBalance = { value: 0, percentageOfAll: 0, containedCoins: "" };

  balanceInUsePerCoin.forEach((coin: Coin) => {
    switch (resolveCryptocurrencyType(coin.name)) {
      case CryptocurrencyType.STABLE_COINS: {
        stableCoinBalance.value += coin.value;
        stableCoinBalance.percentageOfAll += coin.percentageOfAll;
        break;
      }
      case CryptocurrencyType.CRYPTO: {
        cryptoBalance.value += coin.value;
        cryptoBalance.percentageOfAll += coin.percentageOfAll;
        cryptoBalance.containedCoins += " ," + coin.name
        break;
      }
    }
  });

  return [
    new CombinedCoin("Stablecoins", stableCoinBalance.value, stableCoinBalance.percentageOfAll, stableCoinBalance.containedCoins),
    new CombinedCoin("Crypto", cryptoBalance.value, cryptoBalance.percentageOfAll, cryptoBalance.containedCoins),
  ];
}